import styled from 'styled-components';
export const SideBarWrapperStyled = styled.div `
  pointer-events: ${({ open }) => (open ? 'fill' : 'visibleFill')};
  position: relative;
  ${({ variant, open }) => variant === 'desktop'
    ? `width: ${open ? 'max-content' : '100px'};`
    : `transform: translateX(${open ? '0%' : '-100%'});`}
  max-width: max-content;
  background-color: #fff;
  border-radius: 12px;
  border-right: 1px solid rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease-out;
  position: fixed;
  top: 0px;
  left: 0px;
  z-index: 99;
`;
export const SideBarStyled = styled.div `
  pointer-events: all;
  position: relative;
  padding: 0px 24px;
  display: flex;
  flex-direction: column;
  gap: 4px;
  width: max-content;
`;
export const SideBarTitleStyled = styled.span `
  position: relative;
  display: flex;
  padding: ${({ level }) => (level > 0 ? '8px 12px' : '10px 12px')};
  width: ${({ openSide, level }) => (openSide || level > 0 ? 'unset' : 'min-content')};
  align-items: center;
  gap: ${({ openSide }) => (openSide ? '12px' : '0px')};
  align-self: stretch;
  border-radius: 8px;
  margin-left: ${({ level, openSide }) => (openSide ? `calc(${level} * 40px)` : '0px')};
  cursor: pointer;

  ${({ clicked, level }) => clicked && `background-color: ${level === 0 ? '#cce4ff' : '#F6F6F6'};`};

  ${({ level, title, openSide }) => level === 0 &&
    !openSide &&
    title && {
    '&:hover': {
        backgroundColor: '#cce4ff',
        position: 'relative',
        '::before': {
            display: 'block',
            content: `"${title}"`,
            padding: '10px 12px',
            borderRadius: '4px',
            position: 'absolute',
            left: '60px',
            minWidth: 'max-content',
            top: '50%',
            zIndex: 2,
            backgroundColor: '#cce4ff',
            color: '#0057B8',
            fontFamily: 'Poppins',
            fontSize: '14px',
            fontStyle: 'normal',
            fontWeight: 400,
            lineHeight: '20px' /* 142.857% */,
            transform: 'translateY(-50%)',
            boxShadow: '0px 5px 10px -3.887px rgba(0, 0, 0, 0.25)',
        },
        '::after': {
            content: '""',
            position: 'absolute',
            left: '48px',
            top: '46%',
            height: '15px',
            width: '15px',
            borderRadius: '2px',
            backgroundColor: '#cce4ff',
            zIndex: 3,
            transform: 'rotate(45deg) translateY(-50%)',
            boxShadow: '0px 5px 10px -3.887px rgba(0, 0, 0, 0.25)',
        },
    },
}};

  ${({ level, last, openSide }) => level > 0 &&
    openSide &&
    `
  ::before {
    content: '';
    position: absolute;
    left: -15px;
    top: 25%;
    height: 8px;
    border: 2px solid ${level > 0 ? '#0057b8' : 'transparent'};
    width: ${level > 0 ? '13px' : '0px'};
    background-color: transparent;
    border-radius: 0px 8px;
    border-top: 0px;
    border-right: 0px;
  }

  ::after {
    content: '';
    position: absolute;
    left: -15px;
    ${last ? 'top: 0px; height: 30%;' : 'height: 100%;'}
    border: 2px solid ${level > 0 ? '#0057b8' : 'transparent'};
    width: ${level > 0 ? '13px' : '0px'};
    background-color: transparent;
    border-top: 0px;
    border-right: 0px;
    border-bottom: 0px;
  }
  `}

  ${({ level, openSide }) => level > 1 &&
    !openSide &&
    `
    margin-left: 10px;

    ::before {
    content: '';
    position: absolute;
    top: 0px;
    left: -10px;
    width: 8px;
    height: 50%;
    border-left: 2px solid #0057b8;
    border-bottom: ${level > 1 ? '2px solid #0057b8' : '0px'};
    border-bottom-left-radius: 4px;
  }
  `};
`;
export const SideBarTypography = styled.div `
  transform: scaleX(1);
  transition-duration: 0, 0.3s, 0.3s;
  transition-property: visibility, opacity, transform;
  transition-delay: 0;

  &.hidden {
    transform: scaleX(0);
    visibility: hidden;
    opacity: 0;
    transition-duration: 0.3s, 0, 0.3s;
    transition-property: opacity, visibility, transform;
    transition-delay: 0, 0.3s;
    height: 0px;
    width: 0px;

    ${({ level, openSide }) => {
    if (!openSide && level > 0) {
        return `
        visibility: visible;
        opacity: 1;
        transform: scaleX(1);
        background-color: transparent;
        color: #0057B8;
        border-radius: 4px;
        width: max-content;
        height: 100%;
        `;
    }
    return ``;
}}
  }

  color: ${({ level }) => (level > 1 ? '#1F89FF' : '#8E90A4')};
  transition: all 0.3s ease-in-out;
  font-family: 'Poppins';
  font-size: ${({ level }) => (level > 0 ? '12px' : '14px')};
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
  letter-spacing: -0.28px;
  text-align: left;
  flex: 1;

  ${({ clicked, level }) => {
    if (clicked) {
        return `
      color: ${level === 0 ? '#0057b8' : '#1F89FF'};
      `;
    }
    return ``;
}}
`;
export const SideBarDividerStyled = styled.div `
  margin: 24px;
  border: 1px solid #f6f6f6;
`;
export const SideBarCloseButtonStyled = styled.button `
  position: absolute;
  z-index: 3;
  right: 0px;
  top: 34px;
  background-color: #fff;
  transform: translateX(50%);
  padding: 6px;
  border-radius: 8px;
  border: 1px solid #cfd0d8;
  cursor: pointer;
  transition: opacity 0.1s ease-in-out;
  ${({ variant }) => (variant === 'desktop' ? `visibility: visible;` : `visibility: hidden;`)}
`;
export const SideBarBottomContentStyled = styled.div `
  padding: 0px 24px 24px 24px;
`;
export const SideBarTopContentStyled = styled.span `
  padding: 24px 24px 0px 24px;
  align-items: center;
  display: flex;
  gap: 12px;
  justify-content: ${({ openSide, variant }) => openSide || variant === 'mobile' ? 'flex-start' : 'center'};
`;
export const SideBarSubContentWrapperStyled = styled.div `
  opacity: ${({ clicked }) => (clicked ? 1 : 0)};
  width: 100%;
  transform-origin: top;
  background-color: #fff;
  ${({ clicked, openSide, level }) => {
    if (!openSide && level === 0)
        return `
      padding: 10px;
      position: absolute;
      left: 60px;
      top: 0px;
      background-color: #cce4ff;
      border-radius: 4px;
      width: max-content;
      box-shadow: 0px 5px 10px -3.887px rgba(0, 0, 0, 0.25);
    `;
    if (!openSide && level > 0)
        return `
      width: min-content;
      margin-left: 25px;
      background-color: transparent;
      transform: ${clicked ? 'transform: scaleY(1); height: 100%;' : 'transform: scaleY(0); height: 0px;'}
    `;
    return clicked ? 'transform: scaleY(1); height: 100%;' : 'transform: scaleY(0); height: 0px;';
}}
  transition: all 0.3s ease-in-out;

  ${({ level, openSide }) => level > 0 &&
    openSide &&
    `
    ::before {
    content: '';
    position: absolute;
    top: 0px;
    left: 25px;
    width: 38px;
    height: 100%;
    border-left: 2px solid #0057b8;
    border-right: ${level > 1 ? '2px solid #0057b8' : '0px'};
    }
  `};

  ${({ level, openSide }) => level === 0 &&
    !openSide &&
    `
    ::before {
      content: '';
      position: absolute;
      left: -10px;
      top: 15px;
      height: 15px;
      width: 15px;
      border-radius: 2px;
      background-color: #cce4ff;
      zIndex: 3;
      transform: rotate(45deg) translateY(-50%);
    }
  `};

  ${({ level, openSide }) => level > 0 &&
    !openSide &&
    `
    ::after {
    content: '';
    position: absolute;
    border-left: 2px solid #0057b8;
    top: 36px;
    bottom: 20px;
    left: 25px;
  }
  `};
`;
//# sourceMappingURL=styled.js.map